// TEMPORARY — AvantLink server-to-server integration test page.
// Delete this file and remove the /avl-test route from Router.tsx after testing.

import { useContext, useState } from "react";
import { Context } from "../context/AuthContext";
import { UserState } from "../appState";
import ProtectedRoute from "../components/guards/protected-route";

const TEST_PRICE_ID = process.env.REACT_APP_STRIPE_TEST_PRICE_ID || "price_1TTlTIGL1dDBQUpkprCwj3lU";
const orderApiUrl = `${process.env.REACT_APP_API_URL}/api/orders`;

const AvlTest = () => {
  const user = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const avad = localStorage.getItem("avantlink_avad");

  const handleTestCheckout = async () => {
    setLoading(true);
    setError("");
    try {
      const UserToken = localStorage.getItem("ffftoken");
      const UID =
        user?.user?.uid ||
        UserState.getState().uid ||
        localStorage.getItem("fffuser") ||
        "";

      const res = await fetch(`${orderApiUrl}/createCheckoutSession`, {
        method: "POST",
        headers: new Headers({
          "content-type": "application/json",
          authorization: `${UserToken}`,
          "x-user-id": UID,
        }),
        body: JSON.stringify({
          priceId: TEST_PRICE_ID,
          user: UID,
          email:
            user?.user?.email || UserState?.getState()?.email || "",
          avantlink_avad: localStorage.getItem("avantlink_avad") || "",
          avantlink_visitor_id: localStorage.getItem("avantlink_visitor_id") || "",
          avantlink_referrer:
            localStorage.getItem("avantlink_referrer") || "",
          avantlink_landing_url:
            localStorage.getItem("avantlink_landing_url") || "",
          user_agent: navigator.userAgent,
          trialDays: 1,
        }),
      });

      if (res.status === 200) {
        const data = await res.json();
        if (data?.data) {
          window.location.href = data.data;
          return;
        }
      }
      const body = await res.json().catch(() => ({}));
      setError(
        `Checkout failed (${res.status}): ${body?.error || body?.message || "check console"}`
      );
    } catch (err: any) {
      setError(err?.message || "An error occurred");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProtectedRoute>
      <div style={{ padding: "40px", maxWidth: "560px", margin: "60px auto", fontFamily: "sans-serif" }}>
        <p style={{ display: "inline-block", padding: "4px 10px", background: "#fef3c7", color: "#92400e", borderRadius: "4px", fontSize: "12px", fontWeight: 600 }}>
          INTERNAL TEST — DELETE AFTER USE
        </p>

        <h1 style={{ fontSize: "22px", marginTop: "16px" }}>AvantLink S2S Integration Test</h1>
        <p style={{ color: "#555", fontSize: "14px", lineHeight: "1.6" }}>
          Tests the full affiliate attribution chain: click → checkout → 1-day trial → charge → AvantLink postback.
          Uses test product <code>prod_USgr8buQA86aaT</code> ($1/month, 1-day trial).
        </p>

        <div style={{ background: "#f3f4f6", borderRadius: "8px", padding: "16px", margin: "24px 0", fontSize: "13px" }}>
          <div style={{ marginBottom: "8px" }}>
            <strong>avad:</strong>{" "}
            {avad ? (
              <span style={{ color: "#065f46", fontFamily: "monospace" }}>{avad}</span>
            ) : (
              <span style={{ color: "#dc2626" }}>
                NOT SET — you need to land here via a real AvantLink affiliate link first
              </span>
            )}
          </div>
          <div style={{ marginBottom: "8px" }}>
            <strong>referrer:</strong>{" "}
            <span style={{ fontFamily: "monospace" }}>
              {localStorage.getItem("avantlink_referrer") || "none"}
            </span>
          </div>
          <div>
            <strong>price ID:</strong>{" "}
            <span style={{ fontFamily: "monospace", color: "#065f46" }}>{TEST_PRICE_ID}</span>
          </div>
        </div>

        <button
          onClick={handleTestCheckout}
          disabled={loading}
          style={{
            padding: "12px 28px",
            background: "#e86424",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: loading ? "not-allowed" : "pointer",
            fontSize: "15px",
            fontWeight: 600,
          }}
        >
          {loading ? "Redirecting..." : "Start Test Checkout — $1 + 1-day trial"}
        </button>

        {!!error && (
          <p style={{ color: "#dc2626", marginTop: "12px", fontSize: "13px" }}>{error}</p>
        )}

        <p style={{ color: "#9ca3af", fontSize: "12px", marginTop: "32px" }}>
          After checkout, Stripe will redirect to /redeem-code as normal. The AvantLink postback fires when
          the $1 charge hits (~24 hours after trial start). Cancel the subscription in Stripe immediately
          after confirming the postback fires in AvantLink's dashboard.
        </p>
      </div>
    </ProtectedRoute>
  );
};

export default AvlTest;
